import type { IconProps } from '@shopify/polaris';
import type { ThemePageType } from './graphql';

export enum ProviderSource {
  GEMPAGESV7 = 'GEMPAGESV7',
  GEMPAGESV6 = 'GEMPAGESV6',
  SHOPIFY = 'SHOPIFY',
  SHOPIFY_GEMX = 'SHOPIFY_GEMX',
  SHOPIFY_PAGE_FLY = 'SHOPIFY_PAGE_FLY',
  SHOPIFY_FOXIFY = 'SHOPIFY_FOXIFY',
  SHOPIFY_ECOMPOSER = 'SHOPIFY_ECOMPOSER',
  SHOPIFY_SHOGUN = 'SHOPIFY_SHOGUN',
  SHOPIFY_ORIGIN = 'SHOPIFY_ORIGIN',
  SHOPIFY_GP_BACKUP = 'SHOPIFY_GP_BACKUP',
}

export interface IProviderConfig {
  label: string;
  thumbnail: string;
  prefix?: string;
  isMapping?: boolean;
  logo: IconProps;
  pathName?: string;
}

export interface IBaseTemplateInfo {
  type: TemplateType;
  suffix: string;
}

export interface TemplateInfo extends IBaseTemplateInfo {
  fileExtension?: 'json' | 'liquid';
  providerSource?: ProviderSource;
}

export enum TemplateType {
  ALL = 'all',
  HOME = 'index',
  COLLECTION = 'collection',
  COLLECTION_LIST = 'collection-list',
  PRODUCT = 'product',
  ARTICLE = 'article',
  PAGE = 'page',
  CART = 'cart',
  SEARCH = 'search',
  NOT_FOUND = '404',
  BLOG = 'blog',
  PASSWORD = 'password',
  CONTACT = 'contact',
  GIF_CART = 'gif-cart',
  ACCOUNT = 'account',
  CHECKOUT = 'checkout',
  GIFT_CARD = 'gift-card',
}

export type ITemplateAssignedType =
  | TemplateType.HOME
  | TemplateType.PRODUCT
  | TemplateType.COLLECTION
  | TemplateType.PAGE
  | TemplateType.ARTICLE;

export type GPV7TemplateType = ThemePageType;

export type GPV6TemplateType =
  | 'template-page'
  | 'template-article'
  | 'template-index'
  | 'template-product'
  | 'template-collection';

export interface BuildQueryParamsInApp {
  version: 'v6' | 'v7';
  pageId: string;
  shopifyDomain?: string;
}
export interface BuildQueryParamsInAppV7 extends BuildQueryParamsInApp {
  themeId: string;
  type: 'gempagesv7';
  pageType?: GPV7TemplateType;
  gemXFeature?: string;
  campaignId?: string;
}
export interface BuildQueryParamsInAppV6 extends BuildQueryParamsInApp {
  pageHandle?: string;
  pageType?: GPV6TemplateType;
}

export interface ParseTemplateProps {
  assetKey: string;
  providerSourceInfo: Omit<ProviderSourceInfo, 'parseTemplate'>;
}
export interface ProviderSourceInfo {
  providerSource: ProviderSource;
  regex: RegExp;
  regexId?: RegExp;
  parseTemplate: (augments: ParseTemplateProps) => TemplateInfo | undefined;
}

export interface HandleSetTemplateDuplicatedProps {
  key: ProviderSource.GEMPAGESV7;
  value: ITemplateDuplicatedItem;
}
export interface ITemplateDuplicatedItem {
  templateId: string;
  variantId: string;
}
export interface ITemplateDuplicated {
  [ProviderSource.GEMPAGESV7]: ITemplateDuplicatedItem[];
}
